export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/face-2-119d7ee630ccbb412dab816bad55d97c.jpg";